import { render, staticRenderFns } from "./ShopBindAdmin.vue?vue&type=template&id=8dacf4b2&scoped=true"
import script from "./ShopBindAdmin.vue?vue&type=script&lang=ts"
export * from "./ShopBindAdmin.vue?vue&type=script&lang=ts"
import style0 from "./ShopBindAdmin.vue?vue&type=style&index=0&id=8dacf4b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dacf4b2",
  null
  
)

export default component.exports